import { createFileRoute } from "@tanstack/react-router";
import { EventsPage } from "@/components/app/portal/pages/events-page";

export const Route = createFileRoute("/family-portal/events")({
  head: () => ({ meta: [{ title: "Events | People AI" }] }),
  component: EventsPage,
});
